<template>
  <ModalContainer queryParam="f022" ref="modalContainer" size="lg">

    <b-alert v-if="messageAlert" show :variant="messageAlert.variant" class="p-2 text-center">
      {{ messageAlert.text }}
    </b-alert>

    <b-card>

      <h4 class="text-primary text-center mb-3">ADMINISTRACION DE MEDICAMENTOS</h4>

      <div class="mb-1 row" v-if="dataProceso">
        <div class="col">
          <b>Procedimiento:</b> {{ dataProceso.procedimiento}}
        </div>
        <div class="col">
          <b>Paciente: </b> {{ dataProceso.paciente }}
        </div>
      </div>

      <hr>

      <b-row class="my-2">
        <div class="col-4 d-flex align-items-center">
          <label class="mr-1">Fecha:</label>
          <flat-pickr size="sm" class="form-control form-control-sm" v-model="dataForm.fecha" locale="es"
            :config="birthDateConfig" />
        </div>

        <div class="col-12 mt-2">
          <span> Alergias a medicamentos: </span>
          <b-form-textarea rows="2" v-model="dataForm.alergias" />
        </div>

       


      </b-row>

      <hr>

      <div class="d-flex justify-content-end">
        <b-button @click="setVisibleForm" variant="warning">
          {{ viewForm ? 'Ocultar Formulario' : '+ Agregar Item' }}
        </b-button>
      </div>

      <div v-if="viewForm">

        <b-row class="">
          <div class="col-4 d-flex align-items-center">
            <label class="mr-1">Hora:</label>
            <vue-timepicker v-model="itemTemporal.hora" fixed-dropdown-button format="HH:mm" manual-input>
              <template v-slot:dropdownButton>
                <i class="fa-regular fa-clock"></i>
              </template>

            </vue-timepicker>

          </div>
        </b-row>


        <b-row class="d-flex align-items-center my-2">

          <div class="col-3">
            <label>Responsable(s):</label>
            <b-form-checkbox-group v-model="itemTemporal.responsableTipo"
              :options="[{ value: '1', text: 'Doctor' }, { value: '2', text: 'Auxiliar' }, { value: '3', text: 'Paciente' }]"></b-form-checkbox-group>

          </div>

          <div class="col-9">
          <div v-if="itemTemporal.responsableTipo.includes('1')">
            <label>Doctor:</label>
            <SearchOpts v-model="itemTemporal.doctor" :searchService="doctoresService.searchDoctoresByTermSelect"
              :placeholder="'Buscar doctor...'" :minChars="3" />
          </div>

          <div class="mt-1" v-if="itemTemporal.responsableTipo.includes('2')">
            <label>Auxiliar:</label>
            <SearchOpts v-model="itemTemporal.auxiliar" :searchService="auxiliarService.searchAuxiliaresByTermSelect"
              :placeholder="'Buscar auxiliar...'" :minChars="3" />
          </div>
          </div>

        </b-row>

        <b-row class="my-2">
          <div class="col-3">
            <label>Escoja:</label>
            <b-form-select v-model="itemTemporal.medicamentoTipo">
              <b-form-select-option :value="'1'">Medicamento</b-form-select-option>
              <b-form-select-option :value="'2'">Insumo</b-form-select-option>
            </b-form-select>
          </div>

          <div v-if="itemTemporal.medicamentoTipo === '1'" class="col-9">
            <label for="">Medicamento</label>
            <SearchOpts v-model="itemTemporal.medicamento" :searchService="medicamentosService.searchByTerm"
              :placeholder="'Buscar medicamento...'" :establecimiento="establecimientoId" :minChars="3" />
          </div>

          <div v-if="itemTemporal.medicamentoTipo === '2'" class="col-9">
            <label for="">Insumo</label>
            <SearchOpts v-model="itemTemporal.insumo" :searchService="insumoService.searchByTerm"
              :placeholder="'Buscar insumo...'" :establecimiento="establecimientoId" :minChars="3" />
          </div>

        </b-row>
        <b-row class="my-2">

          <div class="col-5 my-1">
            <label> Frecuencia </label>
            <b-form-input v-model="itemTemporal.frecuencia" />
          </div>

          <div class="col-3 my-1">
            <label> Via </label>
            <b-form-input v-model="itemTemporal.via" />
          </div>

          <div class="col-4 my-1">
            <label>Dosis:</label>
            <b-input-group>
              <b-form-input v-model="itemTemporal.dosis" type="number" />

              <template #append>
                <b-form-select v-model="itemTemporal.dosisTipo">
                  <b-form-select-option :value="'ml'">ml</b-form-select-option>
                  <b-form-select-option :value="'gr'">gr</b-form-select-option>
                  <b-form-select-option :value="'l'">l</b-form-select-option>
                  <b-form-select-option :value="'%'">%</b-form-select-option>
                  <b-form-select-option :value="'cc'">cc</b-form-select-option>
                  <b-form-select-option :value="'unidad(es)'">unidad(es)</b-form-select-option>
                </b-form-select>
              </template>
            </b-input-group>
          </div>

        </b-row>


        <div class="d-flex justify-content-end mt-2">
          <b-button @click="agregarEvo" variant="info" size="sm">
            <span class="mr-1">+ Agregar</span>
          </b-button>
        </div>
      </div>

      <b-table class="mt-2" v-if="itemsTabla.length" bordered striped responsive small :items="itemsTabla"
        :fields="fields">

        <template #cell(acciones)="data">
          <b-button @click="eliminarRegistro(data.index)" variant="danger" size="sm">
            <i class="fa-solid fa-trash" />
          </b-button>
        </template>
      </b-table>

      <EmptyResults v-if="!itemsTabla.length" message="No se ha registrado informacion" />

      <div class="d-flex justify-content-end mt-2">
        <b-button variant="primary" @click="onSaveForm">
          Guardar
        </b-button>

      </div>

    </b-card>
  </ModalContainer>
</template>

<script>

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { doctoresService, auxiliarService } from "@/shared/services";
import { SearchOpts, ModalContainer, EmptyResults } from "@/shared/components";
import { insumoService, medicamentosService } from "../../../farmacia/services";
import { getDataForms } from "../../helpers/getDataForms";
import { procedimientosFormulariosService } from "../../services";
import { getEstablecimientoLS } from "../../../../shared/helpers";
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {

  components: {
    flatPickr,
    SearchOpts,
    ModalContainer,
    EmptyResults,
    VueTimepicker
  },

  props: {
    tableAdm: {
      type: Object,
      default: null, // Valor por defecto si no se proporciona
    },
    dataProceso: {
      required:false,
      default:null,
    }
  },

  data() {
    return {
      codigoFormulario: "022",
    

      messageAlert: null,

      viewForm: false,
      itemsTabla: [],
      tokenFormulario: null,


      itemSeleccionado: "1",
      frecuencia: null,
      cantidad: null,
      dosis: "ml",
      medicamentosService,
      insumoService,
      medicamentodosis: "",

      itemTemporalInicial: {
        hora: null,
        via:null,
        responsableTipo: ['1'],
        doctor: null,
        auxiliar: null,

        medicamentoTipo: '1',
        medicamento: null,
        insumo: null,

        frecuencia: null,
        dosis: null,
        dosisTipo: 'unidad(es)',
      },

      itemTemporal: null,

      dataForm: {
        fecha: "",
        alergias: "",
        medicamentosList: [],
      },

      dataAdminMed: {
        fechaActual: "",
        alergiasmed: "",
        table: [],
      },
      medicamento: null,
      insumo: null,
      establecimientoId: null,
      alergiasmed: "",
      userMedicament: "1",
      idProcActual: null,
      doctoresService,
      auxiliarService,

      doctor: null,
      auxiliar: null,

      fechaActual: null,
      horaActual: null,
      birthDateConfig: {
        allowInput: true,
        dateFormat: "Y-m-d", // Solo fecha
      },
      procedimiento: [],

      fields: [
        {
          key: "descripcion",
          label: "dosis, via, frecuencia",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        { key: "hora", label: "Hora", sortable: true, thClass: "text-center" },
        {
          key: "responsable",
          label: "Responsable",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        {
          key: "acciones",
          label: "",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
      ],
    };
  },
  created() {
    this.loadData();
  },

  methods: {


    setInicial() {
      this.dataForm = {
        fecha: "",
        alergias: "",
        medicamentosList: [],
      }

      this.itemTemporal = { ...this.itemTemporalInicial };
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // Meses van de 0 a 11
      const day = String(now.getDate()).padStart(2, "0");

      this.dataForm.fecha = `${year}-${month}-${day}`;
      this.establecimientoId = getEstablecimientoLS().id;
      this.itemTemporal.hora = now.getHours() + ":" + ("0" + now.getMinutes()).slice(-2);
    },


    async loadData() {

      this.setInicial();

      this.tokenProceso = this.$route.query.forms;
      this.tokenFormulario = this.$route.query.f022
      const response = await procedimientosFormulariosService.obtenerFormProcDataByToken(this.tokenFormulario);

      if (!response) {
        this.messageAlert = {
          text: "No existe informacion registrada",
          variant: "warning"
        }
      

        return
      }

      let paciente = `${response.procedimientoCita.consultamedica.cita.paciente.persona.primerApellido} ${response.procedimientoCita.consultamedica.cita.paciente.persona.primerNombre} `

     

      this.messageAlert = {
        text: "Info cargada",
        variant: "success"
      };

      let dataForm = null
      try {
        dataForm = JSON.parse(response.dataJson)
      } catch (error) { console.log("Eror", error) }


      if (dataForm) { this.dataForm = dataForm; }

    },


    setVisibleForm() {
      this.viewForm = !this.viewForm
    },


    async eliminarRegistro(index) {
      const result = await this.$swal.fire({
        title: "Eliminar Registro",
        text: "Esta seguro de eliminar este registro?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Eliminar!",
        cancelButtonText: "Cancelar",
      })

      if (!result.isConfirmed) return;

      this.dataForm.medicamentosList.splice(index, 1);
    },


    agregarEvo() {

      let vacioDoctor = false
      let vacioAuxiliar = false

      let horaFormateada = null

      if (this.itemTemporal.responsableTipo.includes('1') && !this.itemTemporal.doctor){
        vacioDoctor = true
      }
       if (this.itemTemporal.responsableTipo.includes('2') && !this.itemTemporal.auxiliar){
        vacioAuxiliar = true
      }
      if (this.itemTemporal.hora){
        if(this.itemTemporal.hora.HH && this.itemTemporal.hora.mm) {
          horaFormateada = this.itemTemporal.hora.HH + ':'+ this.itemTemporal.hora.mm
        }
        
      }
      if (horaFormateada) {
        this.itemTemporal.hora = horaFormateada
      }
      

      if (
        !this.itemTemporal.hora
        || !this.itemTemporal.responsableTipo.length
        || (vacioDoctor || vacioAuxiliar)
        || !this.itemTemporal.medicamentoTipo
        || (!this.itemTemporal.medicamento && !this.itemTemporal.insumo)
        || !this.itemTemporal.frecuencia
        || !this.itemTemporal.dosis
        || !this.itemTemporal.dosisTipo

      ) {
        this.$swal.fire({
          icon: "warning",
          text: "Todos los campos son obligatorios.",
        });
        return;
      }

      this.dataForm.medicamentosList.push(this.itemTemporal);
      this.clearFormTemporal();
    },


    clearFormTemporal() {
      this.itemTemporal = { ...this.itemTemporalInicial };
      this.viewForm = false;
    },


    async onSaveForm() {

      if (!this.dataForm.fecha || !this.dataForm.alergias || !this.dataForm.medicamentosList.length) {

        await this.$swal.fire({
          icon: "warning",
          text: "Debe agregar informacion",
        });
        return;
      }

      const params = {
        nameForm: this.codigoFormulario,
        dataJson: JSON.stringify(this.dataForm),
        tokenProceso: this.tokenProceso,
        tokenFormulario: this.tokenFormulario,
        idRegistroForm: this.idRegistroForm,
      }

      const responseSave = await procedimientosFormulariosService.guardarData(params);

      if (!responseSave) {

        this.$swal({
          title: "Error",
          text: "No se guardo! Contacte al equipo de desarrollo",
          icon: "error",
          confirmButtonColor: "#089599",
        });
        return;
      }

      await this.$swal.fire({
        icon: "success",
        text: "Guardado correctamente",
      });

      
      await this.$router.push({
        query: {
          ...this.$route.query,
          f022: undefined
        }
      });


      

      // await this.$router.push({ query: { ...this.$route.query, finf: undefined } });
      this.$emit("formulario-guardado");


      //this.$router.go(0);
    },



    setItemsTableMedicamentos(list) {
      this.itemsTabla = list.map((item) => {
        let via = ''
        if (item.via) {via = `via: ${item.via}` }
        const medicamento = item.medicamentoTipo === '1' ? item.medicamento : item.insumo;
        const descripcion = `${medicamento.text} ${item.frecuencia} ${item.dosis} ${item.dosisTipo} ${via} `;
        
        let responsable = ''

        if(item.doctor){
          responsable = 'Dr. ' + item.doctor.text + '/'
        }
        if(item.auxiliar){
          responsable = responsable + 'Aux.'+ item.auxiliar.text + '/'
        }
        if (item.responsableTipo.includes('3')){
          responsable = responsable + 'Paciente'
        }
        
        return {
          descripcion: descripcion,
          hora: item.hora,
          responsable: responsable,
        };
      })
    }

  },

  watch: {

    'dataForm.medicamentosList': {
      deep: true,
      handler(newValue) {
        this.setItemsTableMedicamentos(newValue);
      },
    },

    '$route.query.f022': {
      handler(newValue) {
        if (newValue) { this.loadData() }
      },
    },

  },
};
</script>
